import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Filter } from 'src/app/interfaces';

import {
    AddFavoriteBrand,
    BrandsSearch,
    GetBrands,
    GetProductsSearch,
    GetStandardFilters,
    RemoveFavoriteBrand,
    ResetSearchPage,
    SearchProducts,
    SetListFilters
} from './products.actions';
import { ProductsState } from './products.state';

@Injectable({
    providedIn: 'root'
})
export class ProductsFacade {
    public searchProducts$ = this.store.select(ProductsState.searchProducts);
    public searchFilters$ = this.store.select(ProductsState.searchFilters);
    public listTitle$ = this.store.select(ProductsState.listTitle);
    public brands$ = this.store.select(ProductsState.brands);
    public brandsSearch$ = this.store.select(ProductsState.brandsSearch);
    public searchPagination$ = this.store.select(ProductsState.searchPagination);
    public favBrands$ = this.store.select(ProductsState.favBrands);

    constructor(private store: Store) {}

    getSearchAll() {
        return this.store.dispatch(new GetProductsSearch());
    }

    resetSearchAll() {
        return this.store.dispatch(new ResetSearchPage());
    }

    setListFilters(filters: Filter, title: string) {
        return this.store.dispatch(new SetListFilters(filters, title));
    }

    searchProducts(payload: string, filters?: Filter) {
        return this.store.dispatch(new SearchProducts(payload, filters));
    }

    getAllBrands() {
        return this.store.dispatch(new GetBrands());
    }

    getAllBrandsByName(payload: string) {
        return this.store.dispatch(new BrandsSearch(payload));
    }

    addBrandToFavorites(payload: string) {
        return this.store.dispatch(new AddFavoriteBrand(payload));
    }

    removeBrandFromFavorites(payload: string) {
        return this.store.dispatch(new RemoveFavoriteBrand(payload));
    }

    searchQuery() {
        return this.store.selectSnapshot(ProductsState.searchQuery);
    }

    totalSearchProducts() {
        return this.store.selectSnapshot(ProductsState.totalSearchProducts);
    }

    currentTotalSearchProducts() {
        return this.store.selectSnapshot(ProductsState.currentTotalSearchProducts);
    }

    brands() {
        return this.store.selectSnapshot(ProductsState.brands);
    }

    favBrands() {
        return this.store.selectSnapshot(ProductsState.favBrands);
    }

    getStandardSearchFilters() {
        return this.store.dispatch(new GetStandardFilters());
    }
}
